import './limitedclient0.scss';

export default function LimitedClient0() {
    const faqUrl =
        'https://paycor.my.salesforce.com/lightning/articles/Knowledge/Paycor-Paths-Internal-Frequently-Asked-Questions-FAQ';
    return (
        <div className="limitedclient-container">
            <div className="limitedclient-error-message" data-testid="limitedclient-error-message">
                Paycor associates cannot view Paths pages directly or through Impersonation at this time. This does not
                indicate a problem with the Customer's Path product.
            </div>
            <br></br>
            <div className="limitedclient-error-message" data-testid="limitedclient-error-message">
                Please use another support tool like co-browsing or Zoom to troubleshoot Paths with a Customer. Or,
                access{' '}
                <a href={faqUrl} target="_blank" rel="noreferrer">
                    Paycor Paths Internal FAQ
                </a>{' '}
                for more information.
            </div>
        </div>
    );
}
